import { CoordinatorService } from './coordinator.service';
import { ScriptSettingsGroup } from './script-settings-group';

export class ScriptSettings {
    #coords: CoordinatorService;

    constructor(coords: CoordinatorService) {
        this.#coords = coords;
    }

    log = this.help;
    help() {
        console.log('Settings:');
    }

    get itemList() {
        return new ScriptSettingsGroup(this.#coords, 'itemList');
    }

    get itemDetail() {
        return new ScriptSettingsGroup(this.#coords, 'itemDetail');
    }

    get keywords() {
        return new ScriptSettingsGroup(this.#coords, 'keywords');
    }
}
